<ng-content select="lui-expansion-panel-header"></ng-content>
<div
  class="lui-expansion-panel-body"
  role="region"
  #body
  [@bodyExpansion]="_getExpandedState()"
  (@bodyExpansion.done)="animationComplete.emit($event)"
>
  <div>
    <ng-content select="lui-expansion-panel-content"></ng-content>
    <!-- <ng-content></ng-content> -->
    <!-- <ng-template [cdkPortalOutlet]="_portal"></ng-template> -->
  </div>
</div>
